import { TeamRoleEnum } from '@agilelab/plugin-wb-team-roles-common';

export const TeamRoleAsString: Record<TeamRoleEnum, string> = {
  [TeamRoleEnum.OWNER]: 'Owner',
  [TeamRoleEnum.DATA_ACCESS_MANAGER]: 'Data Access Manager',
  [TeamRoleEnum.DEVELOPER]: 'Developer',
};

export enum TeamRoleAssignmentKindEnum {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
  ASSIGNED_BY_THE_PLATFORM = 'ASSIGNED_BY_THE_PLATFORM',
}

export const TeamRoleAssignmentKindAsString: Record<
  TeamRoleAssignmentKindEnum,
  string
> = {
  [TeamRoleAssignmentKindEnum.FULL]: 'Full',
  [TeamRoleAssignmentKindEnum.LIMITED]: 'Limited',
  [TeamRoleAssignmentKindEnum.ASSIGNED_BY_THE_PLATFORM]:
    'Assigned by the platform with a broader scope',
};

export type TeamRoleAssignment = {
  subject: {
    urn: string;
    displayName: string;
  };
  kinds: TeamRoleAssignmentKindEnum[];
};

export const getTeamRoleAssignmentKindEnum = (
  exactMatch: boolean,
  isLimited: boolean,
) => {
  if (!exactMatch) return TeamRoleAssignmentKindEnum.ASSIGNED_BY_THE_PLATFORM;
  return isLimited
    ? TeamRoleAssignmentKindEnum.LIMITED
    : TeamRoleAssignmentKindEnum.FULL;
};
